import { Reveal } from "./Reveal";

export const SectionHeading = ({ chapter, kicker, title, copy, dark = false, testid }) => (
    <div className="mb-14 md:mb-20 max-w-5xl" data-testid={testid}>
        <Reveal>
            <p className={`font-manrope text-xs md:text-sm font-bold tracking-[0.35em] uppercase mb-4 ${dark ? "text-pink" : "text-pink-dark"}`}>
                {chapter} — {kicker}
            </p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className={`font-oswald uppercase tracking-tight leading-[0.9] text-4xl sm:text-5xl lg:text-7xl ${dark ? "text-white" : "text-ink"}`}>
                {title}
            </h2>
        </Reveal>
        {copy && (
            <Reveal delay={0.16}>
                <p className={`mt-6 text-base md:text-lg max-w-xl leading-relaxed ${dark ? "text-zinc-400" : "text-zinc-500"}`}>
                    {copy}
                </p>
            </Reveal>
        )}
    </div>
);
